/* eslint-disable max-len */
import React from "react";

export const DecorativeEmpty: React.FC = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="96" height="96" rx="48" fill="#E9F3FF"/>
      <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M33.62 36.4609L55.96 58.8009H33.62V36.4609ZM65.62 57.1409L47.96 38.8009H65.62V57.1409Z" fill="#3A76BA"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M30.12 32.94L27 29.82L29.82 27L69.4 66.6L66.58 69.42L59.96 62.8H33.62C31.42 62.8 29.62 61 29.62 58.8L29.64 34.8C29.64 34.12 29.82 33.5 30.12 32.94ZM33.62 58.8H55.96L33.62 36.46V58.8ZM49.62 34.8H65.62C67.82 34.8 69.62 36.6 69.62 38.8V58.8C69.62 59.48 69.44 60.1 69.14 60.66L65.62 57.14V38.8H47.96L39.96 30.8H45.62L49.62 34.8Z" fill="#3A76BA"/>
    </svg>
  );
};
